import React from 'react'
import { FlexRow } from 'elements'
import AvatarDropdown from './AvatarDropdown'

export const HEADER_HEIGHT = 70

export default function Header(props) {
  return (
    <FlexRow
      bg="background.0"
      pl="xxlarge"
      pr="large"
      justifyContent="space-between"
      alignItems="center"
      height={`${HEADER_HEIGHT}px`}
      overflow="visible"
      position="relative"
      zIndex={10}
    >
      {props.children}
      <FlexRow alignItems="center">
        <AvatarDropdown />
      </FlexRow>
    </FlexRow>
  )
}
